import axios from 'axios';

const TIMEOUT = 30000;

const checkMail = (mailadress) => {
  const url = process.env.REACT_APP_TLS_CHECK_URL;
  return axios.post(url, { email: mailadress }, {
    headers: {
      'Cache-Control': 'no-cache, no-store',
      Pragma: 'no-cache',
    },
    validateStatus:(status => status === 200),
    timeout: TIMEOUT,
  }).then(response => response.data);
};


export { checkMail };
